export enum DialogResponseEnum {
  Default,
  Yes,
  No,
}
